import { NgModule } from '@angular/core';
import {FiltersTableComponent} from './filters-table.component';
import {CommonModule} from '@angular/common';
import {DateTimePickerStaticModule} from '../../../tinea-components/dateTime-picker/dateTime-picker.module';
import {TranslatePipe, TranslateDirective} from '@ngx-translate/core';

@NgModule({
  declarations: [
    FiltersTableComponent,
  ],
  imports: [
    CommonModule,
    DateTimePickerStaticModule,
    TranslatePipe, TranslateDirective,
  ],
  exports: [
    FiltersTableComponent,
  ],
})
export class FiltersTableModule {}
